<template>
    <div class="page">
        <!-- <div class="log-tab-bar">
            <el-menu mode="vertical" background-color="#fff" default-active="" @select="checkMenu">
                <el-menu-item index="1">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        <span>登录日志</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="2">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        <span>查询日志</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="3">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        <span>增加日志</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="4">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        <span>修改日志</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="5">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        <span>删除日志</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="6">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        <span>其他日志</span>
                    </template>
                </el-menu-item>
            </el-menu>
        </div> -->
        <div style="display: flex; flex-direction: column; flex: 1;width: 100%;">
            <el-form
                v-if="send"
                :model="queryForm"
                ref="form"
                :rules="rules"
                label-width="80px"
                :inline="true"
                size="small"
                class="query-form"
            >
                <el-form-item label="用户账号" >
                    <el-input :disabled="checked"
                              placeholder="请输入用户账号"
                              v-model="userName"
                              clearable
                              style="width: 180px"
                    > </el-input>
                </el-form-item>

                <el-form-item label="用户日志">
                    <el-select v-model="checked" placeholder="请选择订单状态" size="small" clearable style="width: 180px">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="查询时间">
                    <el-date-picker
                        v-model="dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 180px"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="IP查询">
                    <el-input placeholder="请输入IP地址" v-model="ip" clearable style="width: 180px">  </el-input>
                </el-form-item>
                <el-form-item label="URL查询">
                    <el-input placeholder="请输入URL" v-model="uri" clearable style="width: 180px">  </el-input>
                </el-form-item>
                <el-form-item label="日志类型">
                    <el-select clearable style="width:180px"
                        v-model="logType" placeholder="请选择">
                        <el-option :label="item.value" :value="item.key" v-for="item,index in productStatusEnumList" :key="item"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="check()">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="reset()">重置</el-button>
                </el-form-item>
            </el-form>

            <LogListTable :data="this.data" @send="getData" ref="logListTable" :index="checkIndex" :logObject="mppLog" />
        </div>
    </div>
</template>

<script>
import LogListTable from '@/components/system/LogListTable.vue';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        LogListTable
    },
    data() {
        return {
            activeName: 'login',
            queryForm: {},
            rules: {},
            dateRange: '',
            pickerOptions: {},
            checkIndex: '',
            type: null,
            startDate: '',
            toDate: '',
            ip: '',
            uri: '',
            data: '',
            send: '',
            logType:'',
            userName: '',
            userId: null,
            checked: false,
            productStatusEnumList:[],
            options:[{
                value: false,
                label: '是'
                },
                {
                    value: true,
                    label: '否'
                }],
            mppLog: {
                startDate: '',
                endDate: '',
                ipAddress: '',
                requestUri: '',
                userName: '',
                userId: null,
                logType:'',
            }
        };
    },
    created(){
        this.getProductStatusEnum();
    },
    watch: {
        userName: {
            handler(newVal) {
                console.log(newVal);
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 获取商品状态枚举
        getProductStatusEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'log_type',
            }).then((res) => {
                if (res.success) {
                this.productStatusEnumList = res.enumList
                console.log(this.productStatusEnumList)
                }
            })
        },
        getData(data) {
            this.send = data;
        },
        checkMenu(key, keyPath) {
            this.checkIndex = key;
            setTimeout(() => {
                this.$refs.logListTable.init();
            }, 200);
        },
        changeCheck() {
            if (this.checked) {
                this.userId = '';
            } else {
                this.userId = null;
            }
        },
        reset() {
            this.dateRange = '';
            this.type = null;
            this.ip = '';
            this.uri = '';
            this.userName = '';
            this.userId = null;
            this.logType = '';
            this.check();
        },
        check() {
            this.mppLog.startDate = this.dateRange[0];
            this.mppLog.endDate = this.dateRange[1];
            this.mppLog.ipAddress = this.ip;
            this.mppLog.requestUri = this.uri;
            this.mppLog.userName = this.userName;
            this.mppLog.userId = this.userId;
            this.mppLog.logType = this.logType;
            //this.JSONLog = JSON.stringify(this.mppLog);
            //console.log(typeof(this.mppLog.startDate));
            setTimeout(() => {
                this.$refs.logListTable.firstFun();
            }, 200);
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-menu-item:focus,
.el-menu-item:hover {
    background-color: #ecf4fe !important;
}
.el-menu-item {
    font-size: 13px;
    height: 40px;
    line-height: 40px;
    width: 150px;
}
.page {
    display: flex;
    flex-direction: row;
    .log-tab-bar {
        height: 100%;
        width: 150px;
        margin-right: 15px;
        padding: 10px 10px 10px 0;
        background-color: #fff;
        .search {
            margin: 10px 0;
        }
    }
}
</style>
